export enum PortfolioAnalysisState {
  FileUploading = "FileUploading",
  FileUploaded = "FileUploaded",
  AnalysisInProgress = "AnalysisInProgress",
  AnalysisCompleted = "AnalysisCompleted",
  AnalysisFailed = "AnalysisFailed",
}
